import React from 'react';

const InfoTooltip = ({ text, style = {} }) => {
  return (
    <span style={{ position: 'relative', ...style }}>
      <button
        style={{
          background: '#f3f4f6',
          border: '1px solid #d1d5db',
          borderRadius: '50%',
          width: '16px',
          height: '16px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '10px'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#e5e7eb';
          e.target.nextElementSibling.style.visibility = 'visible';
          e.target.nextElementSibling.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#f3f4f6';
          e.target.nextElementSibling.style.visibility = 'hidden';
          e.target.nextElementSibling.style.opacity = '0';
        }}
      >
        i
      </button>
      <span style={{
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '8px 12px',
        backgroundColor: '#1f2937',
        color: 'white',
        borderRadius: '6px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        visibility: 'hidden',
        opacity: '0',
        transition: 'opacity 0.2s',
        zIndex: 1000,
        pointerEvents: 'none'
      }}>
        {text}
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '5px solid transparent',
          borderRight: '5px solid transparent',
          borderTop: '5px solid #1f2937'
        }}></div>
      </span>
    </span>
  );
};

export default InfoTooltip;